import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { View, Text, TextInput, Button } from 'react-native';
import { GET_PRE_RELEASE_ASSET, UPDATE_SALE_ASSET_PRE_RELEASE } from './queries';
import DataState from '../DataState';

const PreRelease = () => {
  const { hex } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    titleOwnerName: '',
    titleShippingAddress1: '',
    titleShippingAddress2: '',
    titleCity: '',
    titleState: '',
    titleZip: ''
  });

  const { loading, data } = useQuery(GET_PRE_RELEASE_ASSET, {
    variables: { hex },
  });

  const [updatePreRelease, { loading: saving }] = useMutation(UPDATE_SALE_ASSET_PRE_RELEASE);

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      await updatePreRelease({
        variables: {
          hex,
          ...formData
        }
      });
      setSubmitted(true);
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <DataState.Loading />;
  if (!data || !data.preReleaseAsset) return <Text>Invalid Link</Text>;

  if (submitted) {
    return (
      <View style={{ padding: 20 }}>
        <Text style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 20 }}>
          Thank you for sending us your release information.
        </Text>
        <Text style={{ marginBottom: 20 }}>
          We will send you your release shortly!
        </Text>
        <Button
          title="Return Home"
          onPress={() => window.location = '/account/profile'}
        />
      </View>
    );
  }

  return (
    <View style={{ padding: 20 }}>
      <Text style={{ fontSize: 22, fontWeight: 'bold' }}>Provide Title Release Information</Text>
      <Text style={{ marginVertical: 10 }}>
        For: {data.preReleaseAsset.name} (VIN {data.preReleaseAsset.vin})
      </Text>
      <Text>Lot #: {data.preReleaseAsset.soldSaleAsset?.lotNumber}</Text>

      <View style={{ marginVertical: 10 }}>
        <Text>Owner Name</Text>
        <TextInput
          value={formData.titleOwnerName}
          onChangeText={text => handleChange('titleOwnerName', text)}
          style={{ borderWidth: 1, padding: 8, marginBottom: 10 }}
        />

        <Text>Shipping Address 1</Text>
        <TextInput
          value={formData.titleShippingAddress1}
          onChangeText={text => handleChange('titleShippingAddress1', text)}
          style={{ borderWidth: 1, padding: 8, marginBottom: 10 }}
        />

        <Text>Shipping Address 2</Text>
        <TextInput
          value={formData.titleShippingAddress2}
          onChangeText={text => handleChange('titleShippingAddress2', text)}
          style={{ borderWidth: 1, padding: 8, marginBottom: 10 }}
        />

        <Text>City</Text>
        <TextInput
          value={formData.titleCity}
          onChangeText={text => handleChange('titleCity', text)}
          style={{ borderWidth: 1, padding: 8, marginBottom: 10 }}
        />

        <Text>State</Text>
        <TextInput
          value={formData.titleState}
          onChangeText={text => handleChange('titleState', text)}
          style={{ borderWidth: 1, padding: 8, marginBottom: 10 }}
        />

        <Text>Zip</Text>
        <TextInput
          value={formData.titleZip}
          onChangeText={text => handleChange('titleZip', text)}
          style={{ borderWidth: 1, padding: 8, marginBottom: 10 }}
        />

        <Button title={saving ? 'Saving...' : 'Submit'} onPress={handleSubmit} disabled={saving} />
      </View>
    </View>
  );
};

export default PreRelease;
